import React, { Component, ReactNode } from 'react';
import { notify } from 'lib/utils/honeybadgerUtils';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  componentName?: string;
  onError?: (error: Error, errorInfo: React.ErrorInfo) => void;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(): State {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    const { componentName, onError } = this.props;
    const name = componentName || 'Unknown';
    notify(error, `ErrorBoundary/${name}`, {
      componentStack: errorInfo.componentStack,
    });

    if (onError) {
      onError(error, errorInfo);
    }
  }

  render() {
    const { hasError } = this.state;
    const { fallback, children } = this.props;

    if (hasError) {
      if (fallback) {
        return fallback;
      }

      return (
        <div className="bg-[#2c2c2c] rounded-md p-4 text-white">
          <div className="text-sm text-gray-400">
            Something went wrong displaying this content.
          </div>
        </div>
      );
    }

    return children;
  }
}
